module.exports = __webpack_public_path__ + "img/fraud-2.8aceb0bb.jpg";